<template>
  <div
    class="wf-z-50 wf-absolute wf-h-max"
    :style="elementStyles(styles('styles'))"
    :class="elementClasses(classes('containerClasses'), classes('customClasses'))"
  >
    <div
      :class="! previewMode ? 'wf-relative wf-h-full wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-8 wf-pb-2' : ''"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <EditorOptions
        parent="component"
        v-show="hover && ! previewMode"
        :options="menuOptions"
      />
      <EditorComponentSection :key="innerSectionId" :parentModule="parentModule"/>
    </div>
  </div>
</template>

<script>
  import { StylesParser } from '../StylesParser'
  import EditorComponentSection from './EditorComponentSection'
  import EditorPageComponent from '../contracts/EditorPageComponent'
  export default EditorPageComponent.extend({
    components: {EditorComponentSection},
    computed: {
      innerSections() {
        return this.$store.getters['componentSectionModule/elements'](this.element)
      },
      innerSection() {
        return this.innerSections[0]
      },
      innerSectionId() {
        return this.innerSection.id
      },
    },
    methods: {
      elementStyles(styles) {
        let colorStyles = {
          desktop: [],
          tablet: [],
          phone: []
        }
        let color = this.innerSection.styles[this.device].find(style => style.property == 'BackgroundColor')
        if (color) {
          this.$set(colorStyles, this.device, [color])
        }
        return {...(new StylesParser(styles, this.device)).parse(), ...(new StylesParser(colorStyles, this.device)).parse()}
      },
    }
  })
</script>